import { Component, Input, inject } from '@angular/core';
import { RootReducer, Store } from '@app/app.reducers';
import { getProductById } from '@app/product/reducers/product.reducer';
import { DataLayer } from '@app/shared/services/data-layer.service';
import { firstNotEmpty } from '@app/shared/utils/util';
import { of as observableOf } from 'rxjs';

@Component({
	selector: 'g-product-list',
	templateUrl: './product-list.component.html',
	styleUrls: ['./product-list.component.scss'],
	standalone: false,
})
export class ProductListComponent {
	protected store = inject<Store<RootReducer.State>>(Store);
	protected dataLayer = inject(DataLayer);

	@Input({ alias: 'products' }) readonly products$ = observableOf<api.ProductDto[]>([]);
	@Input() readonly listingName = DataLayer.CATEGORY_LISTING;

	productClick(productId: number): void {
		this.store
			.select(getProductById(productId))
			.pipe(firstNotEmpty)
			.subscribe((product) => this.dataLayer.addProductClick(product, this.listingName));
	}
}
